import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import store from "app/config/store";
import App from "app/App";
import { logout } from "modules/login/redux/session.action";

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const isPartnerApi = url.includes("/partner/api/v1/") && !url.includes("/public/invite/");
    if (status === 401 && isPartnerApi) {
      // Let the session revocation finish before the full-page redirect kills
      // in-flight requests.
      await store.dispatch(logout());
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
